import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { randomString } from '../../utils/web/webUtils.js';
import './no-context-menu.scss'; // static propTypes = {
//     groups: PropTypes.array.isRequired,
//     actionType: PropTypes.oneOf(['contextmenu', 'click', 'hover']),
// };

var initialized = false;
var menus = {};

function initialize() {
  if (!initialized) {
    window.addEventListener('keyup', event => {
      if (event.key === 'Escape') {
        closeContextMenus();
      }
    });
    window.addEventListener('click', event => {
      for (var menu of Object.values(menus)) {
        if (menu.isOpen) {
          menu.setIsOpen(false);
        }
      }
    });
    initialized = true;
  }
}

function closeContextMenus() {
  for (var menu of Object.values(menus)) {
    if (menu.isOpen) {
      menu.setIsOpen(false);
    }
  }
}

function NoContextMenu(props) {
  var {
    actionType = 'contextmenu',
    alwaysCentered = false,
    children,
    groups,
    object
  } = props;
  var [isOpen, setIsOpen] = useState(false);
  var [eventValues, setEventValues] = useState({});
  var [openEvent, setOpenEvent] = useState(null);
  initialize();
  useEffect(() => {
    var menuId = randomString();
    menus[menuId] = {
      isOpen,
      setIsOpen
    };
    return () => delete menus[menuId];
  });

  var handleRightClick = event => {
    if (!event.shiftKey && !event.ctrlKey) {
      closeContextMenus();
      var left = null;
      var top = null;

      if (alwaysCentered) {
        var box = event.target.getBoundingClientRect();
        left = box.x + event.target.offsetWidth / 2;
        top = box.y + event.target.offsetHeight / 2;
      } else {
        left = event.clientX;
        top = event.clientY;
      } // 200 is min width, this needs to be the width of the context menu


      if (left + 200 > window.innerWidth) {
        left -= 200;
      }

      event.preventDefault();
      event.stopPropagation();
      setIsOpen(true);
      setEventValues({
        left,
        top
      });
      setOpenEvent(event);
    }
  };

  var handleActionClick = (event, action) => {
    var {
      disabled,
      onClick,
      subMenu
    } = action;

    if (!disabled && !subMenu && typeof onClick === 'function') {
      onClick(object, {
        actionEvent: event,
        openEvent
      });
      setIsOpen(false);
      setOpenEvent(null);
    }
  };

  var propsToAdd = {
    onContextMenu: handleRightClick
  };

  if (actionType === 'click') {
    propsToAdd = {
      onClick: handleRightClick
    };
  }

  var child = /*#__PURE__*/React.cloneElement(React.Children.only(children), propsToAdd);
  var groupsToUse = groups;

  if (isOpen) {
    groupsToUse = groups.map(group => {
      var actions = group.filter(action => {
        var {
          shouldShow
        } = action;

        if (shouldShow === undefined) {
          shouldShow = true;
        }

        if (typeof shouldShow === 'function') {
          shouldShow = shouldShow(object, {
            openEvent
          });
        }

        return !!shouldShow;
      });
      return actions;
    }).filter(group => !!group.length);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, child, isOpen && /*#__PURE__*/React.createElement("div", {
    className: "noContextMenu",
    style: {
      left: eventValues.left,
      top: eventValues.top
    }
  }, groupsToUse.map((group, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, i > 0 && /*#__PURE__*/React.createElement("div", {
    className: "noContextGroupSeperator"
  }), /*#__PURE__*/React.createElement(NoContextGroup, {
    group: group,
    handleActionClick: handleActionClick,
    object: object
  })))));
}

function NoContextGroup(props) {
  var {
    group,
    handleActionClick,
    object
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "noContextGroup"
  }, group.map(action => /*#__PURE__*/React.createElement(NoContextAction, {
    action: action,
    key: action.name,
    handleClick: event => handleActionClick(event, action),
    object: object
  })));
}

function NoContextAction(props) {
  var {
    action: {
      name
    },
    handleClick,
    object
  } = props;
  var [hovered, setHovered] = useState(false);

  var handleMouseEnter = event => {
    setHovered(true); // close sibling submenus
  };

  var handleMouseLeave = event => {
    setHovered(false);
  };

  var actionClassName = classnames('noContextAction', {
    noContextHover: hovered
  });
  return /*#__PURE__*/React.createElement("div", {
    className: actionClassName,
    key: name,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, name);
}

export default NoContextMenu;